// [BD feat] PDP Custom Layout — Gallery Slider (all devices)

class BdGallerySlider extends HTMLElement {
  connectedCallback() {
    this._list = this.querySelector('.product__media-list');
    this._prevBtn = this.querySelector('.bd-pdp__gallery-prev');
    this._nextBtn = this.querySelector('.bd-pdp__gallery-next');
    this._current = this.querySelector('.bd-pdp__slide-current');
    this._total = this.querySelector('.bd-pdp__slide-total');

    if (!this._list) return;

    this._items = Array.from(this._list.querySelectorAll('.product__media-item'));
    this._count = this._items.length;
    this._index = 0;

    if (this._total) this._total.textContent = this._count;
    this._updateCounter();
    this._updateArrows();

    if (this._prevBtn) {
      this._prevBtn.addEventListener('click', () => this._go(-1));
    }
    if (this._nextBtn) {
      this._nextBtn.addEventListener('click', () => this._go(1));
    }

    // Update index when user swipes natively
    this._list.addEventListener('scroll', () => this._onScroll(), { passive: true });
  }

  _go(dir) {
    this._goTo(this._index + dir);
  }

  _goTo(idx) {
    if (!this._items.length) return;
    this._index = Math.max(0, Math.min(idx, this._count - 1));
    // Use scrollLeft directly — scrollIntoView scrolls the page, not the container
    const itemWidth = this._list.offsetWidth;
    this._list.scrollTo({ left: this._index * itemWidth, behavior: 'smooth' });
    this._updateCounter();
    this._updateArrows();
  }

  _onScroll() {
    const itemWidth = this._list.offsetWidth;
    if (!itemWidth) return;
    const newIdx = Math.round(this._list.scrollLeft / itemWidth);
    if (newIdx !== this._index) {
      this._index = Math.max(0, Math.min(newIdx, this._count - 1));
      this._updateCounter();
      this._updateArrows();
    }
  }

  _updateCounter() {
    if (this._current) this._current.textContent = this._index + 1;
  }

  _updateArrows() {
    if (this._prevBtn) this._prevBtn.disabled = this._index === 0;
    if (this._nextBtn) this._nextBtn.disabled = this._index === this._count - 1;
  }
}

if (!customElements.get('bd-gallery-slider')) {
  customElements.define('bd-gallery-slider', BdGallerySlider);
}

// [BD feat] PDP Custom Layout — Gallery Slider (all devices)
